define('Responsive/controllers/ViewController',['require','exports','module','../util/dom','../vendor','../util/array','../util/string','../util/extend','../util/renderComplete','screen-orientation/screen-orientation','es6ish-class/es6ish-class','../adapters/ModalAdapter','../helpers/RootViewHelper'],function(require,exports,module){
    var win=window,
        doc=document,
        undef;

    var fullScreenView = null,
        responsiveViewId='data-responsive-id';


    var ReDom=require('../util/dom'),
        ReVendor=require('../vendor'),
        ReArray=require('../util/array'),
        ReString=require('../util/string'),
        ReExtend=require('../util/extend'),
        ReRenderComplete=require('../util/renderComplete'),
        screenOrientation=require('screen-orientation/screen-orientation'),
        es6ishClass=require('es6ish-class/es6ish-class'),
        ModalAdapter = require('../adapters/ModalAdapter'),
        RootViewHelper = require('../helpers/RootViewHelper');

    function ViewController(){
        this.docRoot=doc.getElementsByTagName('html')[0];
        this.overlayConfig = {};
        this.sizeHandlers =   [];
        this.childViewControllers = [];
        this.setOverlayConfig({
            speed       : 0,
            property    : ReVendor.useTransition && 'opacity' || 'none',
            show        : 1,
            hide        : 0,
            timing      : 'linear',
            delay       : 300,
            splash      : false,
            overlay     : true
        });
    };

    ViewController.prototype = {
        window          : window,
        parentViewController :  null, 
        lastWidth       :  0, 
        currSizeHandler :  null, 
        view            :  null, 
        isFullScreenMode:  false, 
        availableHeight :  0, 
        heightOffset    :  0, 
        containerOffset :  0, 
        offsetView      :  null,
        overlay         :  true, 
        autoHeight      :  0,
        autoHeightInclusive : true,
        modalView       :  null, 
        isModal         :  false, 
        hideAppBar      :  false, 
        fixedHeight     :  -1, 
        rootView        : null,
        defaultSizeHandler : {
            handler  : function(){},
            minWidth : 0,
            maxWidth : 100000
        },
        /**
        * Return current view
        * 
        * @return {HTMLObject} the controller's current view
        */
        getView : function() {
            if(this.view==null) {
                this.loadView();
            }
            return this.view;
        },

        /**
        * Load the controller's view
        *
        * @param {HTMLObject} view: A view to add to this controller
        */
        loadView : function(view) {
            var _self=this,
                resizing=false;
            this.view = view || this.view || this.rootView || doc.createElement("div");
            this.offsetView = this.view;
            this.setClassName("ViewController");
            if(!this.responsiveViewId){
                this.responsiveViewId=(new Date()).getTime();   
            }
            this.view.setAttribute(responsiveViewId,this.responsiveViewId);

            if(this.rootView){
                this.rootViewHelper.addListener();
            }
            return this;

        },

        /**
        * Used to run logic when view loaded (must override)
        */
        viewDidLoad : function() { return this;},

        /**
        * Check if view was cleared from controller
        */
        viewDidUnload : function() {
            this.view = null;
            if(this.modalView){
                this.modalView.destroy();
				this.modalView = undef;
            }
            if(this.rootView){
                this.rootViewHelper.removeListener();
            }
        },

        /*
        * Set the className by repla
        */
        setClassName : function(view, className, replace){
            if(typeof view=="string"){
                replace=className;
                className = view;
                view = this.getView();
            }
            ReDom.setClassName(view,className,replace)
            return this;
        },

        isViewLoaded : function() {
            return this.view !==null;
        },

        viewWillAppear : function() {
            this.draw();
            return this;
        },

        viewDidAppear : function() {
            this.checkHeight();
            return this;
        },
        viewWillDisappear : function() {
            /* russ : merging this through... but i'm not too sure we want to always do this */
            for(var i=0; i<this.childViewControllers.length; i++) {
                this.childViewControllers[i].viewWillDisappear();
            }
            return this;
        },
        viewDidDisappear : function() {
            var parent=this.parentViewController;
            if(this.modalView){
				this.modalView.destroy();
				this.modalView = undef;
            }
            for(var i=0; i<this.childViewControllers.length; i++) {
                this.childViewControllers[i].viewDidDisappear();
            }
            if(this.isModal && parent && parent.modalView && this===parent.modalView.getController()){
                parent.modalView.clean();
                // ReDom.removeNode(parent.modalView.getAnchor(),parent.modalView.getContainer());
                // parent.modalView=null;
            }
            return this;
        },

        dismissModalViewController: function() {
            if(this.modalView){
				this.modalView.destroy();
				this.modalView = undef;
            }
            return this;
        },


        presentFloatingModalViewController:function(viewController,fullscreen) {
            fullscreen=fullscreen || (fullscreen===undef);
            this.modalView=new ModalAdapter(this,viewController,!fullscreen && this);
            this.modalView.create().show();
            return this;
        },

        dismissFloatingModalViewController: function() {
            if(this.modalView){
				this.modalView.destroy();
				this.modalView = undef;
            }
            return this;
        },

        draw : function  () {
            if(this.view==null) {
                this.loadView();
            }
            this.sizeFor(this.getView().offsetWidth);
            this.checkHeight();
            return this;
        },

        checkResized : function(){
            var thisView = this.view;
            if(this.isViewLoaded() && (thisView.offsetWidth != this.lastWidth || this.orientation != screenOrientation())) {
                this.lastWidth = thisView.offsetWidth;
                var sizeHandler = this.getSizeHandlerForWidth( thisView.offsetWidth );
                if(sizeHandler && sizeHandler != this.currSizeHandler) {
                    this.draw();
                }
                for(var i=0; i<this.childViewControllers.length; i++) {
                    this.childViewControllers[i].checkResized();
                }
            }
            return this;
        },

        checkHeight : function(){
            if(this.isViewLoaded()){
                this.setAvailableHeight(this.view.className);
                for(var i=0; i<this.childViewControllers.length; i++) {
                    this.childViewControllers[i].checkHeight();
                }
            }
            return this;
        },

        getAvailableHeight : function(name,useOffset){
            return this.availableHeight;
        },
        
        setAvailableHeight : function(name){
            var newHeight,
                view=this.view;

            if(this.rootView){
                newHeight=this.rootViewHelper.adjustAvailableHeight(newHeight);
            }else {
                newHeight=this.parentViewController ? this.parentViewController.availableHeight : 0;
            }
            if(this.view && this.view != this.offsetView){
                newHeight -= this.offsetView.getBoundingClientRect().top - this.view.getBoundingClientRect().top;
            }
            // if(this.isModal && height!=="auto"){
            //     height += (this.parentViewController && this.parentViewController.heightOffset||0);
            // }

            // if(newHeight && newHeight!=="auto" && this.parentViewController){
            //     newHeight=newHeight - ~~this.parentViewController.heightOffset;
            // }

            if(newHeight==="auto" && this.view){
                ReDom.removeStyleProperty(this.view,'maxHeight');
                ReDom.removeStyleProperty(this.view,'minHeight');
                ReDom.removeStyleProperty(this.view,'height');
            }
            this.availableHeight=newHeight||this.availableHeight;

            return this;
        },

        setRootView: function(view,config) {
            var that=this;
            if(view.view){
                config=view;
                view=config.view;
            }
            config=config||{};
            config.rootView=view;
            delete config.view;
            this.rootViewHelper=new RootViewHelper(this,config);
            return this;
        },
        
        sizeFor : function(width) {
            var sizeHandler = this.getSizeHandlerForWidth(width);
            if(sizeHandler != this.currSizeHandler) {
                this.currSizeHandler = sizeHandler;
                sizeHandler.handler();
            }
        },

        addSizeHandler : function(handler, minWidth, maxWidth,orientation) {
            var that=this,
                ranges;
            if(ReArray.isArray(minWidth)){
                ranges=ReArray.slice(arguments,1).map(function(range){
                    return {
                        handler     : handler,
                        orientation : range[2],
                        minWidth    : range[0],
                        maxWidth    : range[1]
                    };
                });
            } else{
                ranges = {
                    handler     : handler,
                    orientation : orientation,
                    minWidth    : minWidth,
                    maxWidth    : maxWidth
                };
            }
            this.sizeHandlers=that.sizeHandlers.concat(ranges);

            return this;
        },

        getSizeHandlerForWidth : function(width) {
            var i=0,
                len=this.sizeHandlers.length,
                sizeHandlers=this.sizeHandlers,
                sizeHandler,
                orientation=screenOrientation();

            for(; i<len; i++) {
                sizeHandler = sizeHandlers[i];
                if((!sizeHandler.orientation || sizeHandler.orientation===orientation) && width >= sizeHandler.minWidth && width<=sizeHandler.maxWidth) {
                    return sizeHandler;
                }
            }
            return this.defaultSizeHandler;
        },

        showOverlay : function() {
            if(this.view){
                if(!this.overlayConfig.splash){
                    this.getView().setAttribute('data-loading',true);
                    return this;
                }
                this.createOverlay();
                this.overlayView.style[this.overlayConfig.property]=this.overlayConfig.show;

            }
            return this;
        },

        createOverlay : function(){
            if(!this.overlay){
                return;
            }
            if(!this.overlayView){
                var overlayView=doc.createElement("div");
                overlayView.className = "responsive-loading";
                this.overlayView = overlayView;
            }
            this.getView().appendChild(this.overlayView);
            //this.overlayView.style[Re.vendor.transition]='';
            //this.overlayView.style.marginTop=this.heightOffset + 'px';
            this.overlayView.style.display="block"; 
            this.overlayView.style[ReVendor.transition]=this.overlayConfig.transitionString;
            
            return this;
        },

        destroyOverlay : function(){
            var that=this,
                dur=this.overlayConfig.speed + this.overlayConfig.delay;
            setTimeout(function(){
                that.overlayView.style.display="none";
                ReDom.removeNode(that.getView(),that.overlayView);
            },dur);
            return this;
        },

        hideOverlay : function() {
            var that=this,
                config=this.overlayConfig;
            if(this.view){
                if(!config.splash){
                    setTimeout(function(){
                        that.getView().setAttribute('data-loading',false);
                    },config.speed + config.delay);
                    return this;
                }

                if(this.overlayView && this.isViewLoaded()) {
                    if(ReVendor.hasTransition){
                        this.overlayView.style[config.property]=this.overlayConfig.hide;
                    }
                    this.destroyOverlay();
                }
            }
            return this;
        },
        setOverlayConfig : function(conf){
            var config=ReExtend(this.overlayConfig,conf);
            this.overlayConfig.transitionString=[
                    config.property, 
                    config.speed+ 'ms',
                    config.timing,
                    config.delay + 'ms'
                ].join(' ') || '';

            return this;
        },

        setIsInModal : function(val){
            this.isModal=val;
            var i=0,
                len=this.childViewControllers.length,
                kids=this.childViewControllers;
            for(; i<len; i++) {
                kids[i].setIsInModal(val);
            }
            return this;
        },

        getIsInModal : function(){
            return this.isModal;
        }
        
    };
    /*  Allow ViewController to act a subclass factory */
    es6ishClass(ViewController)

    return  ViewController;
});

